import { render, staticRenderFns } from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=template&id=2d86bcf8&scoped=true"
import script from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=script&lang=js"
import style0 from "./SuppliersCategoriesRetrieveUpdate.vue?vue&type=style&index=0&id=2d86bcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86bcf8",
  null
  
)

export default component.exports